import * as React from "react";
import classNames from "classnames";

export function Separator({ className }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="2000px"
      viewBox="0 0 2000 185"
      enableBackground="new 0 0 2000 185"
      xmlSpace="preserve"
      className={classNames("w-full", className)}
    >
      <path d="M1998.5,0C1423.069,210.585,592.111,215.084,0.5,0"></path>
    </svg>
  );
}
